export const features = [
  {
    key: 'COMPARE_PREVENTIVE_COINS',
    defaultValue: 'N/A',
    display: 'Preventive',
    list: 'y',
    compare: 'y',
    planCode: 'IDTL',
    planName: 'IDTL-PL1',
  },
  {
    key: 'COMPARE_BASIC_SERVICE_COINS',
    defaultValue: 'N/A',
    display: 'Basic',
    list: 'y',
    compare: 'y',
    planCode: 'IDTL',
    planName: 'IDTL-PL1',
  },
  {
    key: 'COMPARE_MAJOR_SERVICE_COINS',
    defaultValue: 'N/A',
    display: 'Major',
    list: 'y',
    compare: 'y',
    planCode: 'IDTL',
    planName: 'IDTL-PL1',
  },
  {
    key: 'COMPARE_CAL_YEAR_DEDUCT',
    defaultValue: 'N/A',
    display: 'Calendar Year Deductible',
    list: 'y',
    compare: 'y',
    planCode: 'IDTL',
    planName: 'IDTL-PL1',
  },
  {
    key: 'COMPARE_ANNUAL_MAX',
    defaultValue: 'N/A',
    display: 'Annual Max Plan Pays',
    list: 'y',
    compare: 'y',
    planCode: 'IDTL',
    planName: 'IDTL-PL1',
  },
  {
    key: 'COMPARE_PREVENTIVE_COINS',
    defaultValue: 'N/A',
    display: 'Preventive',
    list: 'y',
    compare: 'n',
    planCode: 'IDTL',
    planName: 'IDTL-PL2',
  },
  {
    key: 'COMPARE_BASIC_SERVICE_COINS',
    defaultValue: 'N/A',
    display: 'Basic',
    list: 'y',
    compare: 'n',
    planCode: 'IDTL',
    planName: 'IDTL-PL2',
  },
  {
    key: 'COMPARE_MAJOR_SERVICE_COINS',
    defaultValue: 'N/A',
    display: 'Major',
    list: 'y',
    compare: 'n',
    planCode: 'IDTL',
    planName: 'IDTL-PL2',
  },
  {
    key: 'COMPARE_CAL_YEAR_DEDUCT',
    defaultValue: 'N/A',
    display: 'Calendar Year Deductible',
    list: 'y',
    compare: 'n',
    planCode: 'IDTL',
    planName: 'IDTL-PL2',
  },
  {
    key: 'COMPARE_ANNUAL_MAX',
    defaultValue: 'N/A',
    display: 'Annual Max Plan Pays',
    list: 'y',
    compare: 'n',
    planCode: 'IDTL',
    planName: 'IDTL-PL2',
  },
  {
    key: 'COMPARE_PREVENTIVE_COINS',
    defaultValue: 'N/A',
    display: 'Preventive',
    list: 'y',
    compare: 'n',
    planCode: 'IDTL',
    planName: 'IDTL-PL3',
  },
  {
    key: 'COMPARE_BASIC_SERVICE_COINS',
    defaultValue: 'N/A',
    display: 'Basic',
    list: 'y',
    compare: 'n',
    planCode: 'IDTL',
    planName: 'IDTL-PL3',
  },
  {
    key: 'COMPARE_MAJOR_SERVICE_COINS',
    defaultValue: 'N/A',
    display: 'Major',
    list: 'y',
    compare: 'n',
    planCode: 'IDTL',
    planName: 'IDTL-PL3',
  },
  {
    key: 'COMPARE_CAL_YEAR_DEDUCT',
    defaultValue: 'N/A',
    display: 'Calendar Year Deductible',
    list: 'y',
    compare: 'n',
    planCode: 'IDTL',
    planName: 'IDTL-PL3',
  },
  {
    key: 'COMPARE_ANNUAL_MAX',
    defaultValue: 'N/A',
    display: 'Annual Max Plan Pays',
    list: 'y',
    compare: 'n',
    planCode: 'IDTL',
    planName: 'IDTL-PL3',
  },
  {
    key: 'examPlusFrames',
    defaultValue: 'N/A',
    display: 'Frames',
    list: 'n',
    compare: 'y',
    planCode: 'VIS1',
  },
  {
    key: 'examPlusStdPlasticLensesSingleVision',
    defaultValue: 'N/A',
    display: 'Standard Plastic Lenses Single Vision<sup>1</sup>',
    list: 'n',
    compare: 'y',
    planCode: 'VIS1',
  },
  {
    key: 'examPlusStdPlasticLensesBifocal',
    defaultValue: 'N/A',
    display: 'Standard Plastic Lenses Bifocal<sup>1</sup>',
    list: 'n',
    compare: 'y',
    planCode: 'VIS1',
  },
  {
    key: 'examPlusStdPlasticLensesLenticular',
    defaultValue: 'N/A',
    display: 'Standard Plastic Lenses Lenticular<sup>1</sup>',
    list: 'n',
    compare: 'y',
    planCode: 'VIS1',
  },
  {
    key: 'examPlusStdPlasticLensesTrifocal',
    defaultValue: 'N/A',
    display: 'Standard Plastic Lenses Trifocal<sup>1</sup>',
    list: 'n',
    compare: 'y',
    planCode: 'VIS1',
  },
  {
    key: 'conventionalContactLenses',
    defaultValue: 'N/A',
    display: 'Contact Lenses Conventional<sup>1</sup>',
    list: 'n',
    compare: 'y',
    planCode: 'VIS1',
  },
  {
    key: 'disposableContactLenses',
    defaultValue: 'N/A',
    display: 'Contact Lenses Disposable<sup>1</sup>',
    list: 'n',
    compare: 'y',
    planCode: 'VIS1',
  },
  {
    key: 'medicallyNecessaryContactLenses',
    defaultValue: 'N/A',
    display: 'Contact Lenses Medically Necessary',
    list: 'n',
    compare: 'y',
    planCode: 'VIS1',
  },
  {
    key: 'examFrequency-Exam',
    defaultValue: 'N/A',
    display: 'Frequency-Exam',
    list: 'n',
    compare: 'y',
    planCode: 'VIS1',
  },
  {
    key: 'examFrequency-Frames',
    defaultValue: 'N/A',
    display: 'Frequency-Frames',
    list: 'n',
    compare: 'y',
    planCode: 'VIS1',
  },
  {
    key: 'examFrequency-Lenses',
    defaultValue: 'N/A',
    display: 'Frequency-Lenses OR Contact Lenses',
    list: 'n',
    compare: 'y',
    planCode: 'VIS1',
  },
  {
    key: 'routineEyeExam',
    defaultValue: 'N/A',
    display: 'Routine Eye Exam Dilation',
    list: 'n',
    compare: 'y',
    planCode: 'VIS1',
  },
  {
    key: 'routineEyeExam',
    defaultValue: 'N/A',
    display: 'Routine Eye Exam',
    list: 'y',
    compare: 'n',
    planCode: 'VIS1',
    planName: 'VIS1-PL1',
  },
  {
    key: 'framesLensesContacts',
    defaultValue: 'N/A',
    display: 'Frames, Standard Plastic Lenses or Contact Lenses',
    list: 'y',
    compare: 'n',
    planCode: 'VIS1',
    planName: 'VIS1-PL1',
  },
  {
    key: 'frequency',
    defaultValue: 'N/A',
    display: 'Frequency',
    list: 'y',
    compare: 'n',
    planCode: 'VIS1',
    planName: 'VIS1-PL1',
  },
  {
    key: 'imaging',
    defaultValue: 'N/A',
    display: 'Retinal Imaging',
    list: 'y',
    compare: 'n',
    planCode: 'VIS1',
    planName: 'VIS1-PL1',
  },
  {
    key: 'routineEyeExam',
    defaultValue: 'N/A',
    display: 'Routine Eye Exam',
    list: 'y',
    compare: 'n',
    planCode: 'VIS1',
    planName: 'VIS1-PL2',
  },
  {
    key: 'frames',
    defaultValue: 'N/A',
    display: 'Frames',
    list: 'y',
    compare: 'n',
    planCode: 'VIS1',
    planName: 'VIS1-PL2',
  },
  {
    key: 'standardLenses',
    defaultValue: 'N/A',
    display: 'Standard Plastic Lenses',
    list: 'y',
    compare: 'n',
    planCode: 'VIS1',
    planName: 'VIS1-PL2',
  },
  {
    key: 'contactLenses',
    defaultValue: 'N/A',
    display: 'Contact Lenses',
    list: 'y',
    compare: 'n',
    planCode: 'VIS1',
    planName: 'VIS1-PL2',
  },
  {
    key: 'frequency',
    defaultValue: 'N/A',
    display: 'Frequency',
    list: 'y',
    compare: 'n',
    planCode: 'VIS1',
    planName: 'VIS1-PL2',
  },
  {
    key: 'imaging',
    defaultValue: 'N/A',
    display: 'Retinal Imaging',
    list: 'y',
    compare: 'n',
    planCode: 'VIS1',
    planName: 'VIS1-PL2',
  },
]
